import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c068b73e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option-item-filter__content" }
const _hoisted_2 = {
  key: 0,
  class: "option-item-filter__all-selected-elements-text"
}
const _hoisted_3 = {
  key: 2,
  class: "option-item-filter__all-selected-elements-text"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "option-item-filter__popover-content option-item-filter__hidden-elements" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = { class: "option-item-filter__popover-content" }

import { PopoverColorEnum, PopoverPositionEnum, TirPmIconView, TirPmPopover } from 'tir-components';
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch,
} from 'vue';
import {
  FilterOptions,
  GetGlobalStatusesItem,
  NamespaceModel,
  SelectedFilterOptions,
} from '../../../models';
import {
  ChartBarIcon,
  ChevronRightIcon,
  GlobeAsiaAustraliaIcon,
  ListBulletIcon,
  RectangleStackIcon,
  Squares2X2Icon,
  TagIcon,
} from 'tir-style-system/icons/outline';
import TirPmSearchInput from 'tir-pm-search-input/src/TirPmSearchInput.vue';
import { OptionFilterEnum } from '../enums';
import FilterParameter from './filter-parameter/FilterParameter.vue';
import { FilterOptionModalItem } from '../models/FilterOptionModalItem';
import { OptionItemModel } from '../models';
import FilterGlobalStatusesParameter from './filter-parameter/components/FilterGlobalStatusesParameter.vue';
import FilterProjectsParameter from './filter-parameter/components/FilterProjectsParameter.vue';
import { ProjectModel } from '@/models';
import { TagModel } from '@/components/task-forms/models';
import TaskParameter from '@/components/task-parameter/task-parameter.vue';
import FilterPointsParameter from './filter-parameter/components/FilterPointsParameter.vue';
import { TaskParameterTypeEnum } from '@/components/task-parameter';
import { DimondIcon, FlagIcon, StatusIcon } from 'tir-style-system/icons/solid';
import FilterNamespacesParameter from './filter-parameter/components/FilterNamespacesParameter.vue';
import { TypeModel } from '@/pages/namespace-types-settings-page/models';
import FilterTypeParameter from './filter-parameter/components/FilterTypeParameter.vue';
import {
  GetDifficultyListItemDetail,
  ProjectQueueTaskListItem,
} from '@/components/tasks-kanban/adapter';
import FilterDifficultysParameter from './filter-parameter/components/FilterDifficultysParameter.vue';
import FilterQueuesParameter from './filter-parameter/components/FilterQueuesParameter.vue';
import FilterStatusesParameter from './filter-parameter/components/FilterStatusesParameter.vue';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'OptionItemFilter',
  props: {
  /**Поле поиска */
  searchField: {
    type: String,
  },
  /**Опции фильтра */
  filterOptions: {
    type: Object as PropType<FilterOptions>,
    required: true,
  },
  /**Опция */
  option: {
    type: Object as PropType<OptionFilterEnum>,
    required: true,
  },
  /**Выбранные элементы фильтра */
  selectedOptionsFilter: {
    type: Object as PropType<SelectedFilterOptions>,
    required: true,
  },
  /**показать только где я админ для проектов точно, для областей, для очередей ...' */
  showOnlyCurrentIsAdmin: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ["toggleItem", "selectAllElements", "getWidthBlockSelectedElem", "searchElements", "scrollFinished", "getProjects", "getTagsProject", "getNamespacesProject", "getTypesNamespace", "getDifficultys", "getQueues", "getStatuses", "getPriorities"],
  setup(__props, { emit }) {

const props = __props;


/**События */

const $filterParameter = ref<InstanceType<typeof FilterParameter>>();
/**Ссылка на компонента поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Ссылка на html элемент блока выбранных элементов */
const $selectedElemBlock = ref<HTMLElement | null>(null);
/** Ширина блока выбранных элементов */
const widthBlockSelectedElem = ref<number>(0);
/**Данная поля поиска */
const currentFieldValue = ref('');
/**Ссылка на поле поиска */
const $inputSearch = ref<InstanceType<typeof TirPmSearchInput>>();

/**Выбраны ли все элементы пункта фильтра */
const isFilterAllSelected = computed(() =>
  filterOptionData.value.isMultiSelect
    ? props.selectedOptionsFilter[props.option]?.length +
        (filterOptionData.value.HiddenElements[props.option]?.length || 0) ===
      props.filterOptions[props.option]?.length
    : props.selectedOptionsFilter[props.option]?.some((elem) => elem.Id === 0),
);
/**id выбранного проекта */
const idSelectedProject = computed(() =>
  Number(props.selectedOptionsFilter.Projects.map((item) => item.Id)),
);
/**id выбранного НС */
const idSelectedNamespace = computed(() =>
  String(props.selectedOptionsFilter.Namespaces.map((item) => item.Id)),
);
/**id выбранной очереди */
const idSelectedQueue = computed(() =>
  String(props.selectedOptionsFilter.Queues.map((item) => item.Id)),
);
/**Пуст ли массив выбранных элементов */
const isSelectionEmpty = computed(() => !props.selectedOptionsFilter[props.option]?.length);
/**Поле поиска */
const searchField = computed({
  get: () => {
    return currentFieldValue.value;
  },
  set: (newValue: string) => {
    currentFieldValue.value = newValue;
    emit('searchElements', newValue, props.option);
  },
});
onUnmounted(() => {
  $inputSearch.value?.value;
});
/**Отображение поповреа */
const isVisiblePopover = computed(() => $popover.value?.visible);
/**Данные опции фильтра */
const filterOptionData = computed<FilterOptionModalItem>(() => {
  switch (props.option) {
    case OptionFilterEnum.GlobalStatuses:
      return {
        Title: 'Глобальный статус',
        Icon: GlobeAsiaAustraliaIcon,
        LabelInputSearch: 'Поиск по статусам',
        Data: props.filterOptions.GlobalStatuses as OptionItemModel[],
        SelectedOptions: props.selectedOptionsFilter.GlobalStatuses,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };

    case OptionFilterEnum.Projects:
      return {
        Title: 'Проект',
        Icon: Squares2X2Icon,
        LabelInputSearch: 'Поиск по проектам',
        Data: props.filterOptions.Projects,
        isMultiSelect: false,
        SelectedOptions: props.selectedOptionsFilter.Projects,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Tags:
      return {
        Title: 'Теги',
        Icon: TagIcon,
        LabelInputSearch: 'Поиск по тегам',
        Data: props.filterOptions.Tags,
        SelectedOptions: props.selectedOptionsFilter.Tags,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Namespaces:
      return {
        Title: 'Рабочая область',
        Icon: DimondIcon,
        LabelInputSearch: 'Поиск по рабочим облостям',
        Data: props.filterOptions.Namespaces,
        SelectedOptions: props.selectedOptionsFilter.Namespaces,
        isMultiSelect: false,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Types:
      return {
        Title: 'Тип',
        Icon: RectangleStackIcon,
        LabelInputSearch: 'Поиск по типам',
        Data: props.filterOptions.Types,
        SelectedOptions: props.selectedOptionsFilter.Types,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Difficultys:
      return {
        Title: 'Сложность',
        Icon: ChartBarIcon,
        LabelInputSearch: 'Поиск по сложности',
        Data: props.filterOptions.Difficultys,
        SelectedOptions: props.selectedOptionsFilter.Difficultys,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Queues:
      return {
        Title: 'Очередь',
        Icon: ListBulletIcon,
        LabelInputSearch: 'Поиск по очередям',
        Data: props.filterOptions.Queues,
        SelectedOptions: props.selectedOptionsFilter.Queues,
        isMultiSelect: false,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Statuses:
      return {
        Title: 'Статус',
        Icon: StatusIcon,
        LabelInputSearch: 'Поиск по статусам',
        Data: props.filterOptions.Statuses,
        SelectedOptions: props.selectedOptionsFilter.Statuses,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
    case OptionFilterEnum.Priorities:
      return {
        Title: 'Приоритет',
        Icon: FlagIcon,
        LabelInputSearch: 'Поиск по приоритетам',
        Data: props.filterOptions.Priorities,
        SelectedOptions: props.selectedOptionsFilter.Priorities,
        isMultiSelect: true,
        HiddenElements: props.selectedOptionsFilter.HiddenElements,
      };
  }
});
/**Отображать компонент в зависимости от опции */
const showComponent = computed(() => {
  switch (props.option) {
    case OptionFilterEnum.GlobalStatuses:
      return FilterGlobalStatusesParameter;
    case OptionFilterEnum.Projects:
      return FilterProjectsParameter;
    case OptionFilterEnum.Tags:
      return FilterPointsParameter;
    case OptionFilterEnum.Namespaces:
      return FilterNamespacesParameter;
    case OptionFilterEnum.Types:
      return FilterTypeParameter;
    case OptionFilterEnum.Difficultys:
      return FilterDifficultysParameter;
    case OptionFilterEnum.Queues:
      return FilterQueuesParameter;
    case OptionFilterEnum.Statuses:
      return FilterPointsParameter;
    case OptionFilterEnum.Priorities:
      return FilterPointsParameter;
  }
});
/**Тип для параметра */
const typeParameter = computed(() => {
  switch (props.option) {
    case OptionFilterEnum.Tags:
      return TaskParameterTypeEnum.Tag;
    case OptionFilterEnum.Statuses:
      return TaskParameterTypeEnum.Status;
    case OptionFilterEnum.Priorities:
      return TaskParameterTypeEnum.Priority;
  }
});
/**Проверка на наличие элементов */
const isDisabled = computed(
  () =>
    !searchField.value &&
    ((props.option === OptionFilterEnum.Priorities && !filterOptionData.value.Data?.length) ||
      (props.option === OptionFilterEnum.Projects && props.filterOptions.Projects?.length === 0)),
);
/**Определяет, должен ли отображаться плейсхолдер по умолчанию  */
const isDefaultPlaceholderVisible = computed(
  () => props.option == OptionFilterEnum.Namespaces || props.option == OptionFilterEnum.Queues,
);
// Вычисляемое свойство, которое возвращает нужный текст при выборе всех элементов
const filterTextSelectedAllElem = computed(() => {
  if (isDisabled.value) return '';

  // if (isFilterAllSelected.value && !isDefaultPlaceholderVisible.value) {
  //   return 'Все';
  // } else {
  //   return 'Не выбрано';
  // }
  return 'Все';
});
/**Выбранные элементы */
const selectedElements = computed(() => {
  const items = filterOptionData.value.SelectedOptions;
  let totalWidth = 0;

  return items.filter((item) => {
    totalWidth += item.Width || 0;
    return totalWidth <= 170;
  });
});
/**Скрытые элементы */
const hiddenElements = computed(() => {
  const items = filterOptionData.value.SelectedOptions;
  let totalWidth = 0;

  const cutoffIndex = items.findIndex((item) => {
    totalWidth += item.Width || 0;
    return totalWidth > 170;
  });

  return cutoffIndex !== -1 ? items.slice(cutoffIndex) : [];
});
/**Переключение чекбокса элемента*/
const toggleItem = async (item: OptionItemModel, type: OptionFilterEnum) => {
  await nextTick();
  emit('toggleItem', item, type, filterOptionData.value.isMultiSelect);
};
/**Переключение чекбокса выбора всех элементов*/
const selectAllElements = (type: OptionFilterEnum) => {
  emit('selectAllElements', type, filterOptionData.value.isMultiSelect);
  // $popover.value?.close();
};
/**Получить статусы */
const getStatuses = (statuses: GetGlobalStatusesItem[], isGlobalStatusChanged: boolean) => {
  emit('getStatuses', statuses, isGlobalStatusChanged);
};

// watch(
//   () => $popover.value?.visible,
//   async () => {
//     console.log('selectedOptionsFilter', props.selectedOptionsFilter);
//     await setTimeout(() => {
//       if (props.option === OptionFilterEnum.Projects) {
//         console.log('selectedOptionsFilter', props.selectedOptionsFilter);
//         $filterParameter?.value?.toggleItem(
//           props.selectedOptionsFilter.Projects[0],
//           OptionFilterEnum.Projects,
//           false,
//         );
//       }
//     }, 100);
//   },
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    ref_key: "$popover",
    ref: $popover,
    width: "17.5rem",
    isNoTeleport: "",
    disableContentBlur: "",
    isDisabled: isDisabled.value,
    isHideTriangle: false,
    position: _unref(PopoverPositionEnum).Right
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        (__props.option !== _unref(OptionFilterEnum).GlobalStatuses)
          ? (_openBlock(), _createBlock(TirPmSearchInput, {
              key: 0,
              ref_key: "$inputSearch",
              ref: $inputSearch,
              class: "option-item-filter__input-search",
              placeholder: "",
              isSmall: "",
              modelValue: searchField.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchField).value = $event)),
              isWithPopup: false,
              label: filterOptionData.value?.LabelInputSearch
            }, null, 8, ["modelValue", "label"]))
          : _createCommentVNode("", true),
        _createVNode(FilterParameter, {
          ref_key: "$filterParameter",
          ref: $filterParameter,
          searchField: searchField.value,
          selectedGlobalStatuses: props.selectedOptionsFilter.GlobalStatuses,
          showComponent: showComponent.value,
          typeParameter: typeParameter.value,
          option: __props.option,
          filterOptionData: filterOptionData.value,
          optionDataItem: filterOptionData.value?.Data,
          selectedOptionsFilter: __props.selectedOptionsFilter,
          idSelectedProject: idSelectedProject.value,
          idSelectedNamespace: idSelectedNamespace.value,
          idSelectedQueue: idSelectedQueue.value,
          showOnlyCurrentIsAdmin: __props.showOnlyCurrentIsAdmin,
          onScrollFinished: _cache[2] || (_cache[2] = ($event: any) => (emit('scrollFinished', $event))),
          onGetTagsProject: _cache[3] || (_cache[3] = ($event: any) => (emit('getTagsProject', $event))),
          onGetQueues: _cache[4] || (_cache[4] = ($event: any) => (emit('getQueues', $event))),
          onGetStatuses: getStatuses,
          onGetNamespacesProject: _cache[5] || (_cache[5] = ($event: any) => (emit('getNamespacesProject', $event))),
          onGetProjects: _cache[6] || (_cache[6] = ($event: any) => (emit('getProjects', $event))),
          onGetTypesNamespace: _cache[7] || (_cache[7] = ($event: any) => (emit('getTypesNamespace', $event))),
          onGetDifficultys: _cache[8] || (_cache[8] = ($event: any) => (emit('getDifficultys', $event))),
          onGetPriorities: _cache[9] || (_cache[9] = ($event: any) => (emit('getPriorities', $event))),
          onToggleItem: toggleItem,
          onSelectAllElements: selectAllElements
        }, null, 8, ["searchField", "selectedGlobalStatuses", "showComponent", "typeParameter", "option", "filterOptionData", "optionDataItem", "selectedOptionsFilter", "idSelectedProject", "idSelectedNamespace", "idSelectedQueue", "showOnlyCurrentIsAdmin"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["option-item-filter__block", { 'option-item-filter__active': isVisiblePopover.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(filterOptionData.value?.Icon), {
            class: _normalizeClass(["option-item-filter__icon", { 'option-item-filter__disabled-style': isDisabled.value }])
          }, null, 8, ["class"])),
          _createElementVNode("div", {
            class: _normalizeClass(["option-item-filter__selected-elements-block", { 'option-item-filter__disabled-style': isDisabled.value }])
          }, [
            _createTextVNode(_toDisplayString(filterOptionData.value?.Title) + ": ", 1),
            (isFilterAllSelected.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(filterTextSelectedAllElem.value), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "option-item-filter__selected-elements",
                  ref_key: "$selectedElemBlock",
                  ref: $selectedElemBlock
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedElements.value, (item) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(showComponent.value), {
                      isShortInfo: "",
                      type: typeParameter.value,
                      key: item.Id,
                      item: item
                    }, null, 8, ["type", "item"]))
                  }), 128))
                ], 512)),
            (isSelectionEmpty.value && !isFilterAllSelected.value && !isDisabled.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (
                __props.option == _unref(OptionFilterEnum).Projects ||
                __props.option == _unref(OptionFilterEnum).Namespaces ||
                __props.option == _unref(OptionFilterEnum).Queues
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Все"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "Не выбрано"))
                ]))
              : _createCommentVNode("", true),
            (props.option === _unref(OptionFilterEnum).Priorities && isDisabled.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(["option-item-filter__all-selected-elements-text", { 'option-item-filter__disabled-style': isDisabled.value }])
                }, " Не найдены ", 2))
              : _createCommentVNode("", true),
            (hiddenElements.value.length && !isFilterAllSelected.value)
              ? (_openBlock(), _createBlock(_unref(TirPmPopover), {
                  key: 4,
                  isTooltip: "",
                  position: _unref(PopoverPositionEnum).Top
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenElements.value, (item) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(showComponent.value), {
                          type: typeParameter.value,
                          key: item.Id,
                          item: item
                        }, null, 8, ["type", "item"]))
                      }), 128))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmIconView), {
                      size: 24,
                      isRounded: "",
                      isBordered: false,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      mainSlot: _withCtx(() => [
                        _createTextVNode(" +" + _toDisplayString(hiddenElements.value.length), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["position"]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (!isDisabled.value)
          ? (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
              key: 0,
              class: "option-item-filter__icon"
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["isDisabled", "position"]))
}
}

})